module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/add_medical_leaders/logo01-10b088c7f83b64736d9fd87ac3a154ff.svg";